import { concatQuery, concatResource } from "./query-string";
import * as request from "./request-helper";

export interface IApiResponse {
  success: string;
  data: any;
  error: string[];
  headers: any;
}
export interface IResource {
  name?: string;
  id?: string | number;
}
export class ApiHelper {
  constructor(protected url = "") {
    this.url = url;
  }
  public setUrl(url: string) {
    this.url = url;
  }
  public async get(queries?: any, resouce?: IResource): Promise<IApiResponse> {
    try {
      const url = resouce
        ? `${this.url}/${concatResource(resouce)}`
        : `${this.url}`;
      const result = await request.get(url, { queries });
      return result;
    } catch (e) {
      throw e;
    }
  }
  public async getById(
    id: number | string,
    resouce?: IResource,
    queries?: any
  ): Promise<IApiResponse> {
    try {
      const url = resouce
        ? `${this.url}/${id}/${concatResource(resouce)}`
        : `${this.url}/${id}`;
      const result = await request.get(url, { queries });
      return result;
    } catch (e) {
      throw e;
    }
  }
  public async getFileById(
    id: number | string,
    resouce?: IResource,
    queries?: any
  ): Promise<IApiResponse> {
    try {
      const url = resouce
        ? `${this.url}/${id}/${concatResource(resouce)}`
        : `${this.url}/${id}`;
      const result = await request.getFile(url, { queries, file: true });
      return result;
    } catch (e) {
      throw e;
    }
  }
  public async create(body: any, resouce?: IResource): Promise<IApiResponse> {
    try {
      const url = resouce
        ? `${this.url}/${concatResource(resouce)}`
        : `${this.url}`;
      const result = await request.post(url, { body });
      return result;
    } catch (e) {
      throw e;
    }
  }
  public async createFileByBody(body: any, resouce?: IResource): Promise<IApiResponse> {
    try {
      const url = resouce
        ? `${this.url}/${concatResource(resouce)}`
        : `${this.url}`;
      const result = await request.post(url, { body, file: true  });
      return result;
    } catch (e) {
      throw e;
    }
  }
  public async createById(
    body: any,
    id: number,
    resouce?: IResource
  ): Promise<IApiResponse> {
    try {
      const url = resouce
        ? `${this.url}/${id}/${concatResource(resouce)}`
        : `${this.url}/${id}`;
      const result = await request.post(url, { body });
      return result;
    } catch (e) {
      throw e;
    }
  }
  public async update(
    body: any,
    id: number | string,
    resouce?: IResource,
    queries?: any
  ): Promise<IApiResponse> {
    let url = id ? `${this.url}/${id}` : `${this.url}`;
    url = resouce ? `${url}/${concatResource(resouce)}` : `${url}`;
    url = queries ? `${url}?${concatQuery(queries)}` : url;

    try {
      const result = await request.put(url, { body });
      return result;
    } catch (e) {
      throw e;
    }
  }
  public async updatelist(
    body: any,
    resouce?: IResource,
    queries?: any
  ): Promise<IApiResponse> {
    let url = `${this.url}`;
    url = resouce ? `${url}/${concatResource(resouce)}` : `${url}`;
    url = queries ? `${url}?${concatQuery(queries)}` : url;

    try {
      const result = await request.put(url, { body });
      return result;
    } catch (e) {
      throw e;
    }
  }

  public async delete(
    id?: number | string,
    queries?: any,
    body?: any
  ): Promise<IApiResponse> {
    let url = id ? `${this.url}/${id}` : `${this.url}`;

    try {
      const result = await request.delete(url, { queries, body });
      return result;
    } catch (e) {
      throw e;
    }
  }
}
